var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"always","body-style":{ padding: '20px' }}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.statData.name))])]),_c('div',{ref:"barChart",staticStyle:{"width":"100%","height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }